<i #i1 *ngIf="!buttonLabel" class="pi tooltip ml-2" (mouseenter)="onMouserEnter($event, i1)" (mouseleave)="onMouserLeave($event, i1)" (click)="handleToggle($event, i1)"></i>
<span #i2 *ngIf="buttonLabel && buttonClass"  [class]="buttonClass" (mouseenter)="onMouserEnter($event, i2)" (mouseleave)="onMouserLeave($event, i2)" (click)="handleToggle($event, i2)">{{buttonLabel}}</span>
<!-- -->
<p-overlayPanel #op2  [appendTo]="'body'" [styleClass]="styleClass + ' info-overlay'" [autoZIndex]="true" [focusOnShow]="true" (onShow)="onOverlayShow()" (onHide)="onOverlayHide()">
  <ng-template pTemplate="content">
    <div style="z-index: 999999" #hoverElement  [innerHtml]="content | safe:'html'"></div>
  </ng-template>
</p-overlayPanel>
